export const ticketRoutes = [
  {
    path: "create",
    name: "create-ticket",
    meta: {
      transitionName: "slide",
      appBarTitle: "pageTitles.tickets.createTicket"
    },
    component: () =>
      import(
        /* webpackChunkName: "create-ticket" */ "@/views/panel/Tickets/CreateTicket/index"
      )
  },
  {
    path: ":ticketId",
    name: "single-ticket",
    meta: {
      transitionName: "slide",
      appBarTitle: "pageTitles.tickets.singleTicket"
    },
    component: () =>
      import(
        /* webpackChunkName: "single-ticket" */ "@/views/panel/Tickets/SingleTicket/index"
      )
  },
  {
    path: "",
    name: "ticket-list",
    meta: {
      transitionName: "slide",
      appBarTitle: "pageTitles.tickets.ticketList"
    },
    component: () =>
      import(
        /* webpackChunkName: "ticket-list" */ "@/views/panel/Tickets/TicketList/index"
      )
  }
];
